import { showError, showSuccess, isRequired } from "./";
import messages from "../messages";

const lang = document.documentElement.lang.startsWith("fr") ? "fr" : "en";

const isEmailValid = (email) => {
  const pattern =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email);
};

const checkEmail = (email) => {
  let valid = false;
  const emailAddress = email.value.trim();
  if (!isRequired(emailAddress)) {
    showError(email, messages[lang].email_required);
  } else if (!isEmailValid(emailAddress)) {
    showError(email, messages[lang].email_invalid);
  } else {
    showSuccess(email);
    valid = true;
  }
  return valid;
};

export default checkEmail;
